import React from 'react';
import ImgRecord from '@/assets/app/images/common/footer/footer-record.png';
import ImgGuide from '@/assets/app/images/common/footer/footer-guide.png';
import ImgAdventure1 from '@/assets/app/images/common/footer/footer-adventure-1.png';
import ImgAdventure2 from '@/assets/app/images/common/footer/footer-adventure-2.png';
import ImgMyInfo from '@/assets/app/images/common/footer/footer-my-info.png';
import ImgEvent from '@/assets/app/images/common/footer/footer-event.png';
import { useLocation, useNavigate } from 'react-router';
import { useModal } from '@/shared/components/ModalProvider';
import useBottomSheetStore from '@/shared/store/UseBottomSheetStore';

interface MenuItem {
  id: string;
  icon?: string;
  icons?: string[]; // 여러 이미지용
  label: string;
  active?: boolean;
  url?: string;
}

const BottomMenu: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const modal = useModal();
  const { openSheet } = useBottomSheetStore();
  const menuItems: MenuItem[] = [
    { id: 'guide', icon: ImgGuide, label: '도감', url: '/book' },
    { id: 'record', icon: ImgRecord, label: '기록', url: '/record' },
    {
      id: 'main',
      icon: ImgAdventure2,
      label: '모험',
      active: true,
      url: '/adventure',
    },
    { id: ImgEvent, icon: ImgEvent, label: '이벤트', url: '/event/streak' },
    { id: ImgMyInfo, icon: ImgMyInfo, label: '내정보', url: '/mypage' },
  ];

  const goUrl = (url?: string) => {
    if (url) {
      navigate(url);
    } else {
      openSheet('message', { type: 'ALERT', message: '이벤트 준비중입니다.' });
    }
  };

  return (
    <div className="bottom-menu">
      <div className="menu-container">
        {menuItems.map(item => (
          <div
            key={item.id}
            className={`menu-item ${location.pathname.indexOf(item.url || 'null') >= 0 ? 'active' : ''}`}
            onClick={() => goUrl(item.url)}
          >
            <img
              src={item.icon}
              alt={item.label}
              style={{
                width: item.id === 'main' ? 40 : 'auto',
                opacity: `${location.pathname.indexOf(item.url || 'null') === -1 ? 0.6 : 1}`,
              }}
            />
            <span className="menu-label">{item.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BottomMenu;
